import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { collection, deleteDoc, doc, getDocs, query, where, writeBatch } from 'firebase/firestore';
import { db } from '../../firebase/Firebase';
import { IAbsence } from '../../interfaces/Types';
import AbsenceUtils from '../../utils/AbsenceUtils';
import TimeUtils from '../../utils/TimeUtils';
import { setAbsences, setAbsencesLastRefresh, setHolidays, setSickDays } from '../slices/absencesSlice';

export const getAbsences = createAsyncThunk('absences/all', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;

  if (action === undefined) action = TimeUtils.getDefaultTimeRange();

  const result: IAbsence[] = [];

  const ref = collection(db, `absences-${user!.uid}`);
  const q = query(ref, where('timestamp', '>=', action.from), where('timestamp', '<=', action.to));
  const response = await getDocs(q);
  if (response.docs !== undefined) {
    response.docs.forEach((item) => {
      result.push(item.data() as IAbsence);
    });
  }

  const holidays = AbsenceUtils.getHolidaysByTimestampRange(result, action.from, action.to);
  thunkAPI.dispatch(setHolidays(holidays));

  const sickDays = AbsenceUtils.getSickDaysByTimestampRange(result, action.from, action.to);
  thunkAPI.dispatch(setSickDays(sickDays));

  thunkAPI.dispatch(setAbsences(result));
  thunkAPI.dispatch(setAbsencesLastRefresh(dayjs().unix()));
});

export const addAbsences = createAsyncThunk('absences/add', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  const batch = writeBatch(db);
  action.forEach((absence: IAbsence) => {
    batch.set(doc(db, `absences-${user!.uid}/${absence.day}`), {
      day: absence.day,
      timestamp: TimeUtils.dateStringToTimestamp(absence.day),
      absencetype: absence.absencetype,
    });
  });

  batch
    .commit()
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      thunkAPI.dispatch(getAbsences(undefined));
    });
});

export const deleteAbsence = createAsyncThunk('absences/delete', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  deleteDoc(doc(db, `absences-${user!.uid}/${action.day}`))
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      thunkAPI.dispatch(getAbsences(undefined));
    });
});
